
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill purple-900",attrs:{"d":"M10.989 24.857l-2.795-4.543a.6.6 0 010-.628l4.306-6.998 3.5 5.687-3.989 6.482a.6.6 0 01-1.022 0z"}}),_c('path',{staticClass:"fill indigo-800",attrs:{"d":"M30.926 7h-5.59a.6.6 0 00-.512.286l-7.63 12.4a.6.6 0 000 .628l2.795 4.543a.6.6 0 001.022 0L31.437 7.914a.6.6 0 00-.51-.914z"}}),_c('path',{staticClass:"fill purple-600",attrs:{"d":"M15 20L7.176 7.285A.6.6 0 006.665 7H1.074a.6.6 0 00-.511.914l10.426 16.943a.6.6 0 001.022 0L15 20z"}}),_c('path',{staticClass:"fill indigo-600",attrs:{"d":"M21.011 24.857a.6.6 0 01-1.022 0L9.563 7.914a.6.6 0 01.51-.914h5.592a.6.6 0 01.51.285L24 20l-2.989 4.857z"}}),_c('path',{staticClass:"fill teal-600",attrs:{"d":"M25 18.375l-3.5-5.688 3.324-5.402A.6.6 0 0125.335 7h5.591a.6.6 0 01.511.914L25 18.375z"}})])
          )
        }
      }
    